import profileReducer from 'store/common/slices/profile';
import navigationReducer from 'store/common/slices/navigation';
import preIdentityReducer from 'features/preIdentity/state/slice';
import { kbaReducer } from 'features/kba/state';
import { sessionSlice } from 'features/onboarding/state/slice';
import generalReducer from 'store/common/slices/general';
import { reauthenticateReducer } from 'features/reauthenticate/state';
import govtIdReducer from 'features/govtId/state/slice';
import govtIdV2Reducer from 'features/govtId/v2/state/slice';
import { connectivityReducer } from 'features/connectivity/state';

export default {
    profile: profileReducer,
    navigation: navigationReducer,
    preIdentity: preIdentityReducer,
    kba: kbaReducer,
    session: sessionSlice.reducer,
    // all govt-ID state lives in the single govtId feature slice
    // (state.govtId). the slice retains only the
    // app-wide RESET_ALL_REDUCERS case.
    govtId: govtIdReducer,
    // Regula/AWS flow state. Shares nothing with govtId above — the two flows are independent.
    govtIdV2: govtIdV2Reducer,
    general: generalReducer,
    reAuthenticate: reauthenticateReducer,
    connectivity: connectivityReducer,
};
